<template>
  <div>
    <v-tabs class="pt-3" v-model="tabActive" color="white" slider-color="primary">
      <v-tab>Grupos de despesas</v-tab>
      <v-tab class="tabStyle">Grupos e tipos de documentos</v-tab>
      <v-tab class="tabStyle">Cadastro de serviços</v-tab>
      <v-tab class="tabStype">Checklists</v-tab>

      <v-tab-item>
        <Expenses />
      </v-tab-item>

      <v-tab-item>
        <DocGroupsList />
      </v-tab-item>

      <v-tab-item>
        <Services />
      </v-tab-item>

      <v-tab-item>
        <Checklists />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import Expenses from '@/components/standardSystem/expenses/Expenses'
import Services from '@/components/standardSystem/services/Services'
import Checklists from '@/components/standardSystem/checklists/Checklists'
import DocGroupsList from '@/components/standardSystem/docsAndGroups/DocGroupsList'

export default {
  name: 'StandardSystem',

  components: {
    DocGroupsList,
    Expenses,
    Services,
    Checklists
  },

  data () {
    return {
      tabActive: 0
    }
  }
}
</script>

<style>
.tabStyle {
  max-width: 275px;
}
</style>
